import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, Observable } from 'rxjs';

export interface ApiResponse<T> {
  status: boolean;
  message: string;
  data: T;
}
export interface CreditUsageResponse {
  total_credits: number;
  used_credits: number;
  remaining_credits: number;
}
export interface CreditUsageLogResponse {
  api_name: string;
  credits_used: number;
  request_id: string;
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
  /** Legacy field; new rows use 0. */
  token_cost: number;
  /** Estimated API spend in USD (from server pricing config). */
  cost_usd: number;
  created_at: string;
}
@Injectable({
  providedIn: 'root',
})
export class Usage {
  private readonly http = inject(HttpClient);
  private readonly API_BASE_URL = environment.apiBaseUrl;
  getCreditUsageInfo(): Observable<CreditUsageResponse | null> {
    return this.http
      .get<ApiResponse<CreditUsageResponse | null>>(`${this.API_BASE_URL}/v1/usage/credit-info`)
      .pipe(map(r => r.data ?? null));
  }
  getCreditUsageLog(): Observable<CreditUsageLogResponse[]> {
    return this.http
      .get<ApiResponse<CreditUsageLogResponse[]>>(`${this.API_BASE_URL}/v1/usage/credit-usage`)
      .pipe(map(r => r.data ?? []));
  }
}
